import request from '@/utils/request'


// 查询回复列表
export function listAnswer(query) {
  return request({
    url: '/answer/answer/list',
    method: 'get',
    params: query
  })
}

// 查询回复分页
export function pageAnswer(query) {
  return request({
    url: '/answer/answer/page',
    method: 'get',
    params: query
  })
}

// 查询回复详细
export function getAnswer(data) {
  return request({
    url: '/answer/answer/detail',
    method: 'get',
    params: data
  })
}

// 新增回复
export function addAnswer(data) {
  return request({
    url: '/answer/answer/add',
    method: 'post',
    data: data
  })
}

// 修改回复
export function updateAnswer(data) {
  return request({
    url: '/answer/answer/edit',
    method: 'post',
    data: data
  })
}

// 删除回复
export function delAnswer(data) {
  return request({
    url: '/answer/answer/delete',
    method: 'post',
    data: data
  })
}
